define('nav',[
  "globals",
  "models/toc",
  "views/nav/toc",
  "views/nav/nav",
  "content",
  "ext/fancytree",
  "bootstrap"
], function (globals, TocModel, TocView, NavView) {
  "use strict";

  $(function () {
    new NavView({
      el: $("#navpane")
    });

    globals.toc = new TocView({
      el: $("#toc"),
      model: new TocModel()
    });
  });
});

